import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Check, Loader2 } from "lucide-react";

const STEPS = [
  { key: "script", label: "Sto scrivendo lo script...", from: 3, to: 28 },
  { key: "voce", label: "Sto creando la voce...", from: 30, to: 68 },
  { key: "montaggio", label: "Sto montando il video...", from: 70, to: 98 },
];

export const CreationProgress = ({ job }) => {
  const [creep, setCreep] = useState(0);
  const [elapsed, setElapsed] = useState(0);
  const idx = Math.max(0, STEPS.findIndex((s) => s.key === job?.fase));
  const step = STEPS[idx];
  const server = job?.progresso ?? 3;

  useEffect(() => {
    setCreep(server);
  }, [server]);

  useEffect(() => {
    const t = setInterval(() => {
      setElapsed((e) => e + 1);
      setCreep((c) => Math.min(c + 0.6, step.to));
    }, 1000);
    return () => clearInterval(t);
  }, [step.to]);

  const pct = Math.round(Math.max(server, creep));
  return (
    <div className="w-full" data-testid="creation-progress">
      <div className="flex items-end justify-between">
        <p className="font-display text-lg font-bold" data-testid="progress-label">{step.label}</p>
        <p className="font-display text-sm font-semibold text-[#52525b]" data-testid="progress-percent">{pct}% · {elapsed}s</p>
      </div>
      <div className="mt-4 h-3 w-full overflow-hidden rounded-full bg-[#e7e7ea]">
        <motion.div className="progress-shine h-full rounded-full bg-[#0066FF]" animate={{ width: `${pct}%` }} transition={{ duration: 0.9, ease: "easeOut" }} />
      </div>
      <ol className="mt-6 space-y-3">
        {STEPS.map((s, i) => {
          const done = i < idx;
          const active = i === idx;
          return (
            <li key={s.key} className={`flex items-center gap-3 text-[0.95rem] transition-colors ${done || active ? "text-[#111111]" : "text-[#71717a]"}`} data-testid={`progress-step-${s.key}`}>
              <span className={`grid h-7 w-7 shrink-0 place-items-center rounded-full ${done ? "bg-[#0066FF] text-white" : active ? "bg-[#0066FF]/10 text-[#0066FF]" : "bg-[#F5F5F7]"}`}>
                {done ? <Check className="h-4 w-4" /> : active ? <Loader2 className="h-4 w-4 animate-spin" /> : <span className="text-xs font-semibold">{i + 1}</span>}
              </span>
              {s.label}
            </li>
          );
        })}
      </ol>
    </div>
  );
};
